import React from 'react';
import Radium from 'radium';

const DeleteIcon = (props) => {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : '24'}
             height={props.height ? props.height : '24'} viewBox="0 0 24 24" fill="none"
             stroke={props.stroke ? props.stroke : 'currentColor'} strokeWidth={props.strokeWidth ? props.strokeWidth : 2}
             strokeLinecap="round" strokeLinejoin="round"
        >
            <path d="M10 11v6"/>
            <path d="M14 11v6"/>
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/>
            <path d="M3 6h18"/>
            <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
        </svg>
    );
};

export default Radium(DeleteIcon);



// WEBPACK FOOTER //
// ./src/assets/icons/DeleteIcon.jsx